module.exports = __webpack_public_path__ + "img/account-icon-dark.416efd0c.svg";